import React from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from '../i18n';
import GlobalStyle from '../styles/global';
import Header from './components/Header';
import MainSection from './components/MainSection';
import AboutSection from './components/AboutSection';
import WorksSection from './components/WorksSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  return (
    <>
      <I18nextProvider>
        <GlobalStyle />
        <Header />
        <MainSection />
        <AboutSection />
        <WorksSection />
        <ContactSection />
        <WhatsAppButton />
        <Footer /> 
      </I18nextProvider>
    </>
  );
}

export default App;
